import { Skeleton } from '@design-system/Skeleton'

interface BoostersBlockersDetailsShimmerProps {
  'data-testid'?: string;
}

const BoostersBlockersDetailsShimmer = ({ 'data-testid': testId }: BoostersBlockersDetailsShimmerProps = {}) => {
  return (
    <section data-testid={testId}>
      <div className="mx-auto container p-4 md:px-8 lg:px-24 lg:py-6 max-w-[960px]" data-testid="boostersBlockersShimmer-container">
        <div className="md:-ml-5" data-testid="boostersBlockersShimmer-spacer"></div>

        <div className="pt-12">
          <Skeleton className="h-8 w-72 mb-4" />
          <Skeleton className="h-6 w-96 mb-8" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <Skeleton className="h-7 mb-6" />
            <Skeleton className="h-7 mb-6" />
            <Skeleton className="h-7 mb-6" />
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <Skeleton className="h-7 mb-6" />
            <Skeleton className="h-7 mb-6" />
            <Skeleton className="h-7 mb-6" />
          </div>
        </div>

        <div className="pt-12">
          <Skeleton className="h-8 w-72 mb-4" />
          <Skeleton className="h-6 w-96 mb-8" />
        </div>

        <div className="flex justify-center md:justify-start gap-4 mt-12">
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={index}
              className="w-40 h-40 rounded-2xl bg-white shadow-sm flex flex-col items-center justify-center p-4"
            >
              <Skeleton className="w-12 h-12 rounded-full mb-4" />
              <Skeleton className="w-24 h-4" />
            </div>
          ))}
        </div>

        <div className="pt-12">
          <Skeleton className="h-8 w-72 mb-4" />
          <Skeleton className="h-6 w-96 mb-8" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <Skeleton className="h-7 w-48 mb-6" />

            <div className="flex items-center justify-between mb-4 border-b border-gray-100 pb-4">
              <div className="flex-1">
                <Skeleton className="h-6 w-3/4 mb-2" />
                <Skeleton className="h-4 w-16" />
              </div>
              <Skeleton className="h-6 w-6" />
            </div>

            <div className="flex items-center justify-between">
              <div className="flex-1">
                <Skeleton className="h-6 w-3/4 mb-2" />
                <Skeleton className="h-4 w-16" />
              </div>
              <Skeleton className="h-6 w-6" />
            </div>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <Skeleton className="h-7 w-48 mb-6" />

            <div className="flex items-center justify-between mb-4 border-b border-gray-100 pb-4">
              <div className="flex-1">
                <Skeleton className="h-6 w-3/4 mb-2" />
                <Skeleton className="h-4 w-16" />
              </div>
              <Skeleton className="h-6 w-6" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <Skeleton className="h-6 w-3/4 mb-2" />
                <Skeleton className="h-4 w-16" />
              </div>
              <Skeleton className="h-6 w-6" />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-center m-4">
        <Skeleton className="h-80 w-full" />
      </div>
    </section>
  )
}

export default BoostersBlockersDetailsShimmer